import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import PedidoItemEstornoForm from './VendaItemForm';
import PedidoItemTrocaForm from './VendaItemForm';
import ModalPadraoForm from './ModalPadraoForm';
import TituloParcelaForm from './TituloParcelaForm';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export default class EstornoVendaForm extends Component {
  state = {
    registro: {
      ve_idf: 0,
      ve_numero: '',
      ve_dt_estorno: moment().format('DD/MM/YYYY'),
      ve_obs: '',
      ve_vlr_estorno: 0,
      ve_vlr_troca: 0,
      ve_vlr_total: 0,
      ve_pessoa: { key: '0' },
      ve_tipo_doc: { key: '0' },
      ve_cond_pagto: { key: '0' },
    },

    modalProdutoEstornoVisible: false,
    modalProdutoTrocaVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,
    tipoTela: '',

    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,

    activeKey: "dados",

    listaProdutosEstorno: [],
    listaProdutosTroca: [],
    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }
      this.setState({
        registro: this.props.registroSelecionado.dados,
        ve_pessoa: this.props.registroSelecionado.dados.ve_pessoa,
        ve_tipo_doc: this.props.registroSelecionado.dados.ve_tipo_doc,
        ve_cond_pagto: this.props.registroSelecionado.dados.ve_cond_pagto,
        listaProdutosEstorno: this.props.registroSelecionado.listaProdutosEstorno ? this.props.registroSelecionado.listaProdutosEstorno : [],
        listaProdutosTroca: this.props.registroSelecionado.listaProdutosTroca ? this.props.registroSelecionado.listaProdutosTroca : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        caixaFechado,
        visualizando: this.props.registroSelecionado.dados.visualizando,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutosEstorno ? this.props.registroSelecionado.listaProdutosEstorno : [], this.props.registroSelecionado.listaProdutosTroca ? this.props.registroSelecionado.listaProdutosTroca : []);
      });

      if (this.props.registroSelecionado.dados.ve_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  onOK = () => {

    if ((!this.state.registro.ve_dt_estorno) || (!moment(this.state.registro.ve_dt_estorno, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.ve_pessoa) || (this.state.registro.ve_pessoa.key === '0') || (this.state.registro.ve_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.listaProdutosEstorno) || (this.state.listaProdutosEstorno.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto do Estorno' });
      return;
    }
    // if (parseFloat(this.state.registro.ve_vlr_total) < 0) {
    //   Modal.warning({ title: 'Aviso!', content: 'O Valor da Diferença não pode ser menor que zero', });
    //   return;
    // }
    if ((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in this.state.listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(Math.abs(this.state.registro.ve_vlr_total))).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total do Título não Confere com o Valor Total das parcelas', });
        return;
      }
    }

    const registro = {
      ve_idf: this.state.registro.ve_idf,
      ve_dt_estorno: moment(this.state.registro.ve_dt_estorno, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ve_numero: this.state.registro.ve_numero ? this.state.registro.ve_numero : '0',
      ve_pessoa: this.state.ve_pessoa.key,
      pes_nome: this.state.ve_pessoa.label,
      ve_tipo_doc: this.state.registro.ve_tipo_doc.key,
      ve_cond_pagto: this.state.registro.ve_cond_pagto.key,
      ve_vlr_estorno: this.state.registro.ve_vlr_estorno,
      ve_vlr_troca: this.state.registro.ve_vlr_troca,
      ve_vlr_total: this.state.registro.ve_vlr_total,
      ve_obs: this.state.registro.ve_obs,
      ve_tipo_estorno: 'E',

      listaProdutosEstorno: this.state.listaProdutosEstorno,
      listaProdutosTroca: this.state.listaProdutosTroca,
      listaParcelas: this.state.listaParcelas,
    };
    this.props.onSalvarClick(registro);
  };

  calculoTotalPedido = (listaProdutosEstorno, listaProdutosTroca) => {
    // console.log('calculoTotalPedido - listaProdutosEstorno: ', listaProdutosEstorno)
    // console.log('calculoTotalPedido - listaProdutosTroca: ', listaProdutosTroca)

    let { registro } = this.state;
    let vlr_estorno = 0;
    let vlr_troca = 0;
    let vlr_total = 0;

    for (var x in listaProdutosEstorno) {
      vlr_estorno = vlr_estorno + parseFloat(listaProdutosEstorno[x].mi_vlr_total);
    };
    vlr_estorno = parseFloat(vlr_estorno.toFixed(2));

    for (var x in listaProdutosTroca) {
      vlr_troca = vlr_troca + parseFloat(listaProdutosTroca[x].mi_vlr_total);
    };
    vlr_troca = parseFloat(vlr_troca.toFixed(2));

    vlr_total = vlr_troca - vlr_estorno;
    vlr_total = parseFloat(vlr_total.toFixed(2));

    // console.log('calculoTotalPedido - vlr_estorno: ', vlr_estorno)
    // console.log('calculoTotalPedido - vlr_troca: ', vlr_troca)
    // console.log('calculoTotalPedido - vlr_total: ', vlr_total)

    registro.ve_vlr_estorno = vlr_estorno;
    registro.ve_vlr_troca = vlr_troca;
    registro.ve_vlr_total = vlr_total;

    this.setState({
      registro,
    });
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ve_pessoa'] = event.ve_pessoa;
    this.setState(event);
  }

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['ve_dt_estorno'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ ve_dt_estorno: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }







  // ----------------------------------------------------------------
  // PRODUTOS ESTORNO
  // ----------------------------------------------------------------

  onFecharModalProdutoEstornoClick = () => {
    // console.log('onFecharModalProdutoEstornoClick')
    this.setState({
      modalProdutoEstornoVisible: false,
    });
  }

  onSalvarProdutoEstornoClick = (listaProdutosEstorno) => {
    // console.log('onSalvarProdutoEstornoClick: ', listaProdutosEstorno)
    this.setState({
      modalProdutoEstornoVisible: false,
      listaProdutosEstorno,
    },
      this.calculoTotalPedido(listaProdutosEstorno, this.state.listaProdutosTroca)
    );
  }

  onNovoProdutoEstorno = (event) => {
    this.setState({
      modalProdutoEstornoVisible: true,
      produtoEstornoSelecionado: {
        listaProdutos: this.state.listaProdutosEstorno,
        editando: false,
        tipoTela: 'EST',
        registro: {
          mi_seq: 0,
          mi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          mi_qtde: 1,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosEstornoClick = (reg) => {
    this.setState({
      modalProdutoEstornoVisible: true,
      produtoEstornoSelecionado: {
        listaProdutos: this.state.listaProdutosEstorno,
        editando: true,
        tipoTela: 'EST',
        registro: {
          mi_item: {
            key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
            label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: reg.mi_item,
            pest_tamanho: reg.mi_item_tamanho,
            pest_cor: reg.mi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_cod_barras: reg.prod_cod_barras,
          mi_qtde: reg.mi_qtde,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,
          tipoItem: 'P',
        }
      }
    });
  }

  onExcluirProdutosEstornoClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutosEstorno = [...this.state.listaProdutosEstorno];
        const index = listaProdutosEstorno.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutosEstorno.splice(index, 1);
        this.setState({
          listaProdutosEstorno,
        },
          this.calculoTotalPedido(listaProdutosEstorno, this.state.listaProdutosTroca)
        );
      }
    })
  }



  // ----------------------------------------------------------------
  // PRODUTOS TROCA
  // ----------------------------------------------------------------

  onFecharModalProdutoTrocaClick = () => {
    // console.log('onFecharModalProdutoTrocaClick')
    this.setState({
      modalProdutoTrocaVisible: false,
    });
  }

  onSalvarProdutoTrocaClick = (listaProdutosTroca) => {
    // console.log('onSalvarProdutoTrocaClick: ', listaProdutosTroca)
    this.setState({
      modalProdutoTrocaVisible: false,
      listaProdutosTroca,
    },
      this.calculoTotalPedido(this.state.listaProdutosEstorno, listaProdutosTroca)
    );
  }

  onNovoProdutoTroca = (event) => {
    this.setState({
      modalProdutoTrocaVisible: true,
      produtoTrocaSelecionado: {
        listaProdutos: this.state.listaProdutosTroca,
        editando: false,
        tipoTela: 'TRO',
        registro: {
          mi_seq: 0,
          mi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          mi_qtde: 1,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosTrocaClick = (reg) => {
    this.setState({
      modalProdutoTrocaVisible: true,
      produtoTrocaSelecionado: {
        listaProdutos: this.state.listaProdutosTroca,
        editando: true,
        tipoTela: 'TRO',
        registro: {
          mi_item: {
            key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
            label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: reg.mi_item,
            pest_tamanho: reg.mi_item_tamanho,
            pest_cor: reg.mi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_cod_barras: reg.prod_cod_barras,
          mi_qtde: reg.mi_qtde,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,
          tipoItem: 'P',
        }
      }
    });
  }

  onExcluirProdutosTrocaClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutosTroca = [...this.state.listaProdutosTroca];
        const index = listaProdutosTroca.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutosTroca.splice(index, 1);
        this.setState({
          listaProdutosTroca,
        },
          this.calculoTotalPedido(this.state.listaProdutosEstorno, listaProdutosTroca)
        );
      }
    })
  }




  renderValor = (ve_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ve_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  renderAcoesProdutosEstorno = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosEstornoClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosEstornoClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  renderAcoesProdutosTroca = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosTrocaClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosTrocaClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };




  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.ve_tipo_doc) || (this.state.registro.ve_tipo_doc.key === '0') || (this.state.registro.ve_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.ve_cond_pagto) || (this.state.registro.ve_cond_pagto.key === '0') || (this.state.registro.ve_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.ve_vlr_total) !== 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.ve_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.ve_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.ve_dt_estorno, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.ve_dt_estorno, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(Math.abs(this.state.registro.ve_vlr_total)) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.ve_dt_estorno, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.ve_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.ve_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(Math.abs(this.state.registro.ve_vlr_total))) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(Math.abs(this.state.registro.ve_vlr_total))).toFixed(2));

          vlrDif = vlrDif * (-1);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }
    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ve_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.ve_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['ve_tipo_doc'] = event.ve_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['ve_cond_pagto'] = event.ve_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  // ----------------------------------------------------------------



  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoTela: 'pessoas'
    });
  }

  onCadProdutosClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoTela: 'produtos'
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
      tipoTela: ''
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { carregandoForm, listaProdutosEstorno, listaProdutosTroca, listaParcelas, produtoEstornoSelecionado, produtoTrocaSelecionado,
      vlrDifParc, vlrTotalParc, caixaFechado,
      modalListaVisible, modalParcelaVisible, modalProdutoEstornoVisible, modalProdutoTrocaVisible, tipoTela } = this.state;

    const { ve_idf, ve_numero, ve_dt_estorno, ve_pessoa, ve_obs, ve_cond_pagto, ve_tipo_doc,
      ve_vlr_total, ve_vlr_Estorno, ve_vlr_troca } = this.state.registro;

    // console.log('CancelarVendaForm.this.state: ', this.state);

    return (
      <Modal
        title={ve_idf ? (this.state.visualizando ? "Estorno" : "Edição de Estorno") : "Inclusão de Estorno Vendas"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >
        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={tipoTela}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <PedidoItemEstornoForm
          visivel={modalProdutoEstornoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoEstornoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoEstornoClick}
          produtoSelecionado={produtoEstornoSelecionado}
        />

        <PedidoItemTrocaForm
          visivel={modalProdutoTrocaVisible}
          onSalvarProdutoClick={this.onSalvarProdutoTrocaClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoTrocaClick}
          produtoSelecionado={produtoTrocaSelecionado}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={ve_vlr_total}
          condPagto={ve_cond_pagto}
        />

        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados do Estorno
                      </span>
                    </div>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="ve_numero"
                        ref="ve_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={ve_numero}
                        readOnly
                      />
                    </Col>

                    <Col xs={24} sm={6} style={{ marginTop: 3 }} className="camposEspacoDireita">
                      <span>Data Estorno *</span>
                      <DatePicker
                        onChange={this.onDateChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(ve_dt_estorno, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={11}>
                      <PessoaFrame
                        label="Cliente *"
                        id="ve_pessoa"
                        value={ve_pessoa}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        disabled={caixaFechado}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>
                    <Col xs={24} sm={1} style={{ marginTop: 24 }}>
                      <Tooltip title="Cadastro de Clientes" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Valor Estorno</span>
                      <InputForm
                        type="number"
                        id="ve_vlr_Estorno"
                        ref="ve_vlr_Estorno"
                        value={ve_vlr_Estorno}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Valor Troca</span>
                      <InputForm
                        type="number"
                        id="ve_vlr_troca"
                        ref="ve_vlr_troca"
                        value={ve_vlr_troca}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                      <span>Valor Diferença</span>
                      <InputForm
                        type="number"
                        id="ve_vlr_total"
                        ref="ve_vlr_total"
                        value={ve_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} style={{ marginTop: -20 }}>
                      <span>OBS</span>
                      <InputForm
                        id="ve_obs"
                        ref="ve_obs"
                        value={ve_obs}
                        maxLength={200}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Produtos para Estornar" key="produtosEstorno">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProdutoEstorno}
                      icon="plus"
                      className="btn-primary"
                    > Novo Produto
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutosEstorno}
                  rowKey={(listaProdutosEstorno => listaProdutosEstorno.mi_item + '_' + listaProdutosEstorno.mi_item_tamanho + '_' + listaProdutosEstorno.mi_item_cor)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizando || caixaFechado ? null : (
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutosEstorno}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                  )}
                </Table>
              </div>
            </TabPane>

            <TabPane tab="Produtos para Troca" key="produtosTroca">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProdutoTroca}
                      icon="plus"
                      className="btn-primary"
                    > Novo Produto
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutosTroca}
                  rowKey={(listaProdutosTroca => listaProdutosTroca.mi_item + '_' + listaProdutosTroca.mi_item_tamanho + '_' + listaProdutosTroca.mi_item_cor)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizando || caixaFechado ? null : (
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutosTroca}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                  )}
                </Table>
              </div>
            </TabPane>



            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 350 }}>
                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="ve_tipo_doc"
                          value={ve_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="ve_cond_pagto"
                          value={ve_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(ve_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar || caixaFechado ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EstornoVendaForm.js